module.exports = __webpack_public_path__ + "static/img/home_03.465f997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_03.jpg
// module id = VkCb
// module chunks = 1